(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tree-dealer-inquiry"] && !Shopify.designMode) return;
  try {
    
(() => {
  const destination = 'AW-18548510498/FzDPCIvP168dEKKez4xF';
  const maxAge = 2 * 60 * 60 * 1000;
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {} };
  const clear = key => { try { sessionStorage.removeItem(key); } catch {} };
  const allowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return Boolean(privacy?.marketingAllowed() && privacy?.analyticsProcessingAllowed() && privacy?.saleOfDataAllowed());
  };
  const init = element => {
    if (element.dataset.bound === 'true' || element.dataset.editor === 'true') return;
    element.dataset.bound = 'true';
    const form = element.closest('form');
    const key = 'tree_dealer_inquiry_v1:' + location.pathname;
    if (element.dataset.errors === 'true') clear(key);
    form?.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      const id = crypto.randomUUID();
      const input = form.querySelector('[data-inquiry-id]');
      if (input) input.value = id;
      write(key, { id, created:Date.now(), state:'pending' });
    });
    const update = () => {
      if (!allowed()) return;
      const pending = read(key);
      if (element.dataset.accepted !== 'true' || !pending) return;
      if (pending.state !== 'pending' && pending.state !== 'sent') return;
      if (pending.state === 'sent' && pending.channel === 'shared') return;
      if (!/^[0-9a-f-]{36}$/i.test(pending.id) || Date.now() - pending.created < 0 || Date.now() - pending.created > maxAge) { clear(key); return; }
      window.dataLayer = window.dataLayer || [];
      const gtag = function() { window.dataLayer.push(arguments); };
      write(key, { ...pending, state:'sent', channel:'shared' });
      gtag('event', 'conversion', { send_to:destination, value:0, currency:'USD', transaction_id:pending.id, event_callback:() => { element.dataset.measurement = 'processed'; } });
      element.dataset.measurement = 'queued';
    };
    document.addEventListener('visitorConsentCollected', update);
    if (window.Shopify?.customerPrivacy) update();
    else window.Shopify?.loadFeatures?.([{ name:'consent-tracking-api', version:'0.2' }], error => { if (!error) update(); });
  };
  const boot = () => document.querySelectorAll('[data-tree-dealer-inquiry]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
